export const WIZARD_INITIALIZED = "wizard_initialized";
export const SET_WIZARD_NUM_OF_STEPS = "set_wizard_num_of_steps";
export const UPDATE_WIZARD_STEP = "update_wizard_step";

export const WIZARD_STARTED = "wizard_started";
export const WIZARD_STOPPED = "wizard_stopped";
export const WIZARD_STEP_UPDATED = "wizard_step_updated";
export const WIZARD_PREV = "wizard_prev";
export const WIZARD_NEXT = "wizard_next";
export const WIZARD_FIRST = "wizard_first";
export const WIZARD_LAST = "wizard_last";
export const WIZARD_ON_FINISH = "wizard_on_finish";
export const WIZARD_RESET_FINISH = "wizard_reset_finish";
export const WIZARD_STEP_SELECTED = "wizard_step_selected";
export const WIZARD_STEP_ENABLED = "wizard_step_enabled";
export const WIZARD_STEP_DISABLED = "wizard_step_disabled";
export const WIZARD_STEPS_UPDATED = "wizard_steps_updated";